import script from "./cateList.vue?vue&type=script&setup=true&lang=js"
export * from "./cateList.vue?vue&type=script&setup=true&lang=js"

import "./cateList.vue?vue&type=style&index=0&id=7e95952e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e95952e"]])

export default __exports__